/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SenderAgentType {
  Sms = 1,
  Mms = 2,
  Email = 3,
  Voice = 4,
  InternationalSms = 5,
  SocialMedia = 6
}
